module.exports = __webpack_public_path__ + "static/media/maxim_russian.b50a1773.mp3";